import { Component, OnInit } from '@angular/core';
import {COMMON_CONSTANTS, MANAGE_LINE_CONST } from '../../../common/core/common.constants';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UtilsService } from 'src/app/services/utils.service';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
import { WindowServiceService } from 'src/app/services/window-service.service';

@Component({
  selector: 'app-account-verification',
  templateUrl: './account-verification.component.html',
  styleUrls: ['./account-verification.component.scss'],
})
export class AccountVerificationComponent implements OnInit {
header: any;
bodyTxt: any;
isSwitchAccount: boolean;
authoringContentData: any;
switchedBan: any;
error = false;
selectedLines: any = [];
is_IOT_Role = this._helperUtilSvc.IsIOTRole();
constructor(public manageLineService: ManageLineService, public utilsSvc: UtilsService,
              private _cacheSvc: HttpCacheService, private _loaderSvc: LoaderService,
              private _helperUtilSvc: HelperUtilityService, private _windowService: WindowServiceService) { }

ngOnInit() {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();

  }

byPassVerification() {
    this.manageLineService.submitBanForm();
  }

verificationBan() {
    this.manageLineService.submitBanForm();
  }

windowReload() {
    this._windowService.location.reload();
  }
switchAcct() {
    this.manageLineService.close();
    this._loaderSvc.start();
    if(!this.is_IOT_Role){
      this.manageLineService.getManageLineDetail(this.switchedBan, COMMON_CONSTANTS.COUNT_ONE).subscribe((response) => {
        if (response.message === COMMON_CONSTANTS.ALERT_TYPES.SUCCESS_MESSAGE) {
          this._loaderSvc.stop();
          this._cacheSvc.putInSessionStoarage(MANAGE_LINE_CONST.PREVIOUS_SELECTED_LINES, JSON.stringify(this.selectedLines));
          this._cacheSvc.putInSessionStoarage(MANAGE_LINE_CONST.BAN, this.switchedBan);
          this.windowReload();
        } else {
          this._loaderSvc.stop();
          this.utilsSvc.errorHandling(response);
        }
      }, (err) => {
        this._loaderSvc.stop();
        this.error = true;
        this.utilsSvc.errorHandling(err);
      });
    }
  }

}
